<script>
import Api from './Api'
export default {

  data() {
    return {
      apiToken: null,
      isError: false,
      isLoading: false
    }
  },

  methods: {
    verifyApiToken() {
      this.isError = false
      this.isLoading = true
      Api.verifyApiToken(this.apiToken, (success)=>{
        this.isError = !success
        this.isLoading = false
        if (success) {
          this.$emit('success')
        }
      })
    }
  }

}
</script>

<template>

  <div class="column is-8 is-offset-2">
    <h3 class="title has-text-grey">Dev-Kit RFID reader</h3>
    <p class="subtitle has-text-grey">Please provide your MOQO API token to continue.</p>
    <div class="box">
      <form @submit.prevent="verifyApiToken">
        <b-loading :active="isLoading"></b-loading>
        <b-field label="API token" :type="isError ? 'is-danger' : ''" class="has-text-left">
          <b-input placeholder="Bearer XYZ....." type="textarea" v-model="apiToken"></b-input>
        </b-field>

        <button class="button is-block is-info is-large is-fullwidth">Login</button>

        <br>
        <p class="is-size-7">You can create an API token in your MOQO account settings (using prerelease right now).</p>
      </form>
    </div>

  </div>

</template>

<style>
</style>